// extracted by mini-css-extract-plugin
export var BtnV2 = "animations-module--BtnV2--1bc86";
export var BtnV2Black = "animations-module--BtnV2--black--e3e79";
export var BtnV2Borderless = "animations-module--BtnV2--borderless--db354";
export var BtnV2Cloud = "animations-module--BtnV2--cloud--8f164";
export var BtnV2Disabled = "animations-module--BtnV2--disabled--44030";
export var BtnV2Focusable = "animations-module--BtnV2--focusable--6e18e";
export var BtnV2Fullwidth = "animations-module--BtnV2--fullwidth--52594";
export var BtnV2Gold = "animations-module--BtnV2--gold--9f62a";
export var BtnV2Grey = "animations-module--BtnV2--grey--dbff9";
export var BtnV2Icon = "animations-module--BtnV2--icon--bd002";
export var BtnV2Lg = "animations-module--BtnV2--lg--71858";
export var BtnV2Midnight = "animations-module--BtnV2--midnight--49c85";
export var BtnV2Multiline = "animations-module--BtnV2--multiline--6598c";
export var BtnV2Nofocus = "animations-module--BtnV2--nofocus--f9ee8";
export var BtnV2Secondary = "animations-module--BtnV2--secondary--c2189";
export var BtnV2Sm = "animations-module--BtnV2--sm--15dff";
export var BtnV2Solid = "animations-module--BtnV2--solid--0ae7d";
export var BtnV2Square = "animations-module--BtnV2--square--4a207";
export var BtnV2Success = "animations-module--BtnV2--success--dd984";
export var BtnV2Text = "animations-module--BtnV2--text--ee8a0";
export var BtnV2Warning = "animations-module--BtnV2--warning--c392b";
export var BtnV2White = "animations-module--BtnV2--white--0b852";
export var BtnV2Xl = "animations-module--BtnV2--xl--e5cf8";
export var BtnV2Yellow = "animations-module--BtnV2--yellow--1686e";
export var ColorBlock = "animations-module--ColorBlock--0fb48";
export var ColorBlockColorGrey = "animations-module--ColorBlock--colorGrey--9b68a";
export var ColorBlockGrey = "animations-module--ColorBlock--grey--625f1";
export var ColorBlockMidGrey = "animations-module--ColorBlock--midGrey--75fd5";
export var ColorBlockPink = "animations-module--ColorBlock--pink--f830b";
export var ColorBlockPrimary = "animations-module--ColorBlock--primary--0e975";
export var ColorBlockPrimaryDark = "animations-module--ColorBlock--primaryDark--731b2";
export var ColorBlockPrimaryLight = "animations-module--ColorBlock--primaryLight--20b15";
export var ColorBlockPrimaryMid = "animations-module--ColorBlock--primaryMid--2fa56";
export var ColorBlockPurple = "animations-module--ColorBlock--purple--777ab";
export var ColorBlockRed = "animations-module--ColorBlock--red--d1914";
export var ColorBlockSecondary = "animations-module--ColorBlock--secondary--0b0e4";
export var ColorBlockSecondaryDark = "animations-module--ColorBlock--secondaryDark--8e7f4";
export var ColorBlockSecondaryLight = "animations-module--ColorBlock--secondaryLight--78ca1";
export var ColorBlockSecondaryMid = "animations-module--ColorBlock--secondaryMid--a7cb2";
export var ColorBlockText = "animations-module--ColorBlock--text--665a2";
export var ColorBlockYellow = "animations-module--ColorBlock--yellow--c248b";
export var ColorBlocks = "animations-module--ColorBlocks--0c2cc";
export var DashboardTopoptions = "animations-module--Dashboard--topoptions--fe3af";
export var HideEmbedded = "animations-module--HideEmbedded--81d20";
export var ShowEmbedded = "animations-module--ShowEmbedded--7a489";
export var Template__descriptionContent = "animations-module--Template__description-content--f64a6";
export var __active = "animations-module--__active--cc728";
export var __custom = "animations-module--__custom--3af2f";
export var _pin = "animations-module--_pin--6c247";
export var _pinText = "animations-module--_pinText--507d4";
export var aliceCarousel__dots = "animations-module--alice-carousel__dots--5c12e";
export var aliceCarousel__dotsItem = "animations-module--alice-carousel__dots-item--a4b50";
export var btnGroup = "animations-module--btn-group--aa676";
export var ccCompliance = "animations-module--cc-compliance--bb172";
export var fadeIn = "animations-module--fadeIn--4ebf6";
export var h1 = "animations-module--h1--da0fb";
export var h2 = "animations-module--h2--aac48";
export var h3 = "animations-module--h3--65a94";
export var h4 = "animations-module--h4--4560b";
export var link = "animations-module--link--7a8f1";
export var maxWidth = "animations-module--max-width--8c092";
export var menuOpen = "animations-module--menu-open--8296b";
export var noChildPMb = "animations-module--no-child-p-mb--206f6";
export var nobar = "animations-module--nobar--526de";
export var pin = "animations-module--pin--35d1d";
export var seogroup = "animations-module--seogroup--0c3e5";